(() => {
  const section = document.querySelector('[data-returns-support]')
  if (!section) return
  const items = section.querySelector('[data-support-items]')
  section.querySelectorAll('[data-support-view]').forEach((button) => {
    button.addEventListener('click', () => {
      const isList = button.dataset.supportView === 'list'
      items.classList.toggle('is-list', isList)
      section.querySelectorAll('[data-support-view]').forEach((item) => {
        const active = item === button
        item.classList.toggle('is-active', active)
        item.setAttribute('aria-pressed', String(active))
      })
    })
  })
})()
